import SessionsApi from '../api/sessions';
import BookingSlots from '../api/booking-slots';
import i18n from '@/translations';

export default {
  namespaced: true,
  state: {
    sessions: [],
    selectedSession: null,
    loadingSessions: false,
  },
  getters: {
    allSessions(state) {
      return state.sessions;
    },
    selectedSession(state) {
      return state.selectedSession;
    },
    loadingSessions(state) {
      return state.loadingSessions;
    },
  },
  actions: {
    getSessions(context, params) {
      context.commit('SET_LOADING_SESSIONS', true);
      return new Promise((resolve, reject) => {
        SessionsApi.getSessions(params)
          .then((response) => {
            context.commit('SET_SESSIONS', {
              sessions: response,
              currentUser: context.rootState.users.user,
            });
            context.commit('SET_LOADING_SESSIONS', false);
            resolve(response);
          })
          .catch((error) => {
            context.commit('SET_LOADING_SESSIONS', false);
            reject(error);
          });
      });
    },
    getSelectedSession(context, sessionId) {
      return new Promise((resolve, reject) => {
        SessionsApi.getSession(sessionId)
          .then((response) => {
            context.commit('SET_SELECTED_SESSION', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async setSelectedSession(context, session) {
      await context.commit('SET_SELECTED_SESSION', session);
    },
    async createSession(context, session) {
      console.log('saving session');
      try {
        let response;
        if (session.sessionType === 'One-on-One') {
          response = await SessionsApi.createOneOnOneSession(session);
        } else {
          response = await SessionsApi.createGroupSession(session);
        }

        context.commit('SET_SELECTED_SESSION', response.session);
        console.log('session created', response.session._id);

        return response.session;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async updateSession(context, session) {
      try {
        console.log('saving session');

        await SessionsApi.updateSession(session);

        return session;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async deleteSession(context, session) {
      console.log('deleting session');

      try {
        await SessionsApi.deleteSession(session);

        console.log('session deleted');
        if (session.sessionType === 'One-on-One' && session.slot) {
          await BookingSlots.releaseSlot(session.slot);
        }

        context.commit('SET_SELECTED_SESSION', null);

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
  },
  mutations: {
    SET_SESSIONS: (state, { sessions, currentUser }) => {
      state.sessions = sessions.map((session) => {
        let title = session.title;

        if (session.sessionType === 'One-on-One' && session.created_by) {
          // creator perspective, show coach name
          if (currentUser._id === session.created_by._id) {
            title = i18n.global.t('components.session_card.one_on_one_title', {
              name: `${session.coaches[0].first_name} ${session.coaches[0].last_name}`,
            });
          }

          // coach perspective, show creator/student name
          title = i18n.global.t('components.session_card.one_on_one_title', {
            name: `${session.created_by.first_name} ${session.created_by.last_name}`,
          });
        }

        return {
          ...session,
          title,
        };
      }).sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA;
      });
    },
    SET_SELECTED_SESSION: (state, session) => {
      state.selectedSession = session;
    },
    SET_LOADING_SESSIONS: (state, loading) => {
      state.loadingSessions = loading;
    },
  },
};
